import StaffSubcontractorSelect from "./staff-subcontractor-select";
import StaffWorkerRolesField from "./staff-worker-roles-field";


const StaffManagementFormFields = {
    SubcontractorSelect: StaffSubcontractorSelect,
    WorkerRoles: StaffWorkerRolesField,
};

export default StaffManagementFormFields;
